module.exports = __webpack_public_path__ + "static/banner-mobile-ae8cbda345a0557f176ed1c02f511295.png";